import { PromotionsByYearChart } from './PromotionsByYearChart'
import { TargetTitlesChart } from './TargetTitlesChart'
import { PromotionDecisionRateChart } from './PromotionDecisionRateChart'
import { PacketsByDecisionChart } from './PacketsByDecisionChart'
import { PacketsByStatusChart } from './PacketsByStatusChart'
import { PacketsByManagerChart } from './PacketsByManagerChart'
import { PacketsBySeniorLeaderChart } from './PacketsBySeniorLeaderChart'

export function InsightsDashboard() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Insights</h1>
      </div>

      {/* Charts Grid */}
      <div className="space-y-16">
        {/* Top row - Packets by Decision and Status (50% each) */}
        <div className="grid gap-6 md:grid-cols-2">
          <PacketsByDecisionChart />
          <PacketsByStatusChart />
        </div>

        {/* Second row - Promotions by Year (full width) */}
        <div className="grid gap-6">
          <PromotionsByYearChart />
        </div>

        {/* Third row - Promotion Decision Rate by Year (full width) */}
        <div className="grid gap-6">
          <PromotionDecisionRateChart />
        </div>

        {/* Fourth row - Target Titles (full width) */}
        <div className="grid gap-6">
          <TargetTitlesChart />
        </div>

        {/* Bottom row - Packets by Manager and Senior Leader (50% each) */}
        <div className="grid gap-6 md:grid-cols-2">
          <PacketsByManagerChart />
          <PacketsBySeniorLeaderChart />
        </div>
      </div>
    </div>
  )
} 